module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs"
  }, [_vm._t("default", null, {
    toggle: _vm.toggle,
    active: _vm.active
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm._t("items", null, {
    active: _vm.active
  })], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae038d0c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Tabs.vue
// module id = t80f
// module chunks = 1